import { render } from "./Report.vue?vue&type=template&id=5c6abf6b"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
script.render = render

export default script